import { format } from "date-fns";
import { DATETIME_DISPLAY_FORMATS } from "../lib/time";

export function DisplayTime({ startDate, hideEventStartTime }: { startDate: number; hideEventStartTime?: boolean }) {
  const timeFormat = hideEventStartTime
    ? DATETIME_DISPLAY_FORMATS.SHORT_DAY_OF_WEEK_SHORT_MONTH_SHORT_DAY_FULL_YEAR
    : DATETIME_DISPLAY_FORMATS.SHORT_DAY_OF_WEEK_SHORT_MONTH_SHORT_DAY_FULL_YEAR_TWELVE_HOUR_PADDED;
  if (startDate) {
    return <time dateTime={`${startDate}`}>{format(new Date(startDate), timeFormat)}</time>;
  }
  return null;
}
